module.exports = __webpack_public_path__ + "img/bmr-demon.75dfa056.png";